import { showToast } from '../redux/actions/activeToast.actions';
import { ToastName } from '../types/ToastNames';
import { Dispatch } from 'redux';
import { TeamMemberTableRowData, isTeamRowData } from '../common/types';

export const showRoleUpdatedToast = (dispatch: Dispatch, entity: TeamMemberTableRowData, roles: string[]) => {
  dispatch(showToast(ToastName.RoleUpdated, {
    translationParams: {
      email: isTeamRowData(entity) ? entity.accountName : entity.email,
      // Used for toasting a successful role update
      aRole: roles.join(', '),
    },
  }));
};
